'use strict';

var _ = require('underscore');
var deepExtend = require('./deepExtend');

module.exports = function(src) {
	return deepExtend({}, src);
};
